module.exports = __webpack_public_path__ + "img/Ja.fa5ebb01.png";